import { Component, Input} from '@angular/core';

export enum Size {
    ELARGE = 'elarge',
    LARGE = 'large',
    MEDIUM = 'medium',
    SMALL = 'small',
}

export enum LoaderType {
    REGULAR = 'regular',
    PERCENTAGE = 'percentage',
}

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
    progressCircle = document.querySelector('.large-progress-circle');

    sizeLoader = Size;
    loaderTP = LoaderType
    @Input() size: Size = Size.ELARGE;
    @Input() progressCharged: number = 0;
    @Input() loaderType: LoaderType = LoaderType.REGULAR;

    constructor() {}
}
